import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
  Card,
  Select,
  Input,
  Tag,
  Typography,
  Space,
  Avatar,
  Button,
  DatePicker,
  // notification,
  Empty,
  Popconfirm,
  message,
  Switch,
  Tooltip
} from 'antd';
import {
  SearchOutlined,
  HolderOutlined,
  StarFilled,
  StarOutlined,
  CloseOutlined,
  ThunderboltFilled,
  SendOutlined,
  DeleteOutlined,
  EditOutlined,
  UserAddOutlined,
  ClockCircleOutlined,
  SyncOutlined,
  LogoutOutlined
} from '@ant-design/icons';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import styles from '../../../Dashboard/index.module.less';
import CustomButton from '@/common/CustomButton';
import { useDispatch } from 'react-redux';
import { getLoggedInUser } from 'utilities/helpers';
import {
  getAllTasks,
  getAllUsers,
  updateTaskAssignment,
  getAssignedTasks,
  unAssignedTask,
  highlightTask,
  publishPlan,
  getAllClients,
  unhighlightTask,
  createNewTask,
  updateUserLeaveStatus
} from '../../redux/slice';
import FloatingActionButton from '../../../FloatingActionButton';
import TaskAssignModal from '../TaskAssignModal';
import { Link, useNavigate } from 'react-router-dom';
import {
  isBefore,
  startOfDay,
  format,
  parseISO,
  isSameDay,
  addDays,
  isAfter
} from 'date-fns';
import { EXECUTIVE } from 'utilities/roleRights';
import LeaveModal from '../LeaveModal';
import LeavesModal from '../LeavesModal';
// import { useSelector } from 'react-redux';

const { Title, Text } = Typography;

const TaskPlanner = () => {
  const [search, setSearch] = useState('');
  const [assignedTasks, setAssignedTasks] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [team, setTeam] = useState([]);
  const [date, setDate] = useState('');
  const [clients, setClients] = useState('');
  const [clientId, setClientId] = useState('');
  const [editTaskId, setEditTaskId] = useState(null);
  const [isTaskAssignModal, setIsTaskAssignModalOpen] = useState(null);
  const [highlightedTasksMemberIds, setHighlightedTasksMemberIds] = useState(
    []
  );
  const [leaveModalOpen, setLeaveModalOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [leavesModalOpen, setLeavesModalOpen] = useState(false);

  const navigate = useNavigate();

  const user = getLoggedInUser();
  const dispatch = useDispatch();
  useEffect(() => {
    handleGetAllTasks();
    handleGetAssignedTasks();
  }, [search, clientId]);

  useEffect(() => {
    handleGetAllUsers();
    handleGetAllClients();
  }, [assignedTasks]);

  const handleGetAllTasks = () => {
    const payload = { search, client_id: clientId };
    dispatch(getAllTasks(payload)).then((res) => {
      if (res?.payload?.success) {
        const formattedUsers = res?.payload?.data.map((task) => ({
          ...task,
          id: String(task.id)
        }));
        setTasks(formattedUsers);
      }
    });
  };

  const onChange = (e) => {
    setClientId(e);
  };
  const handleGetAllClients = () => {
    const payload = { search };
    dispatch(getAllClients(payload)).then((res) => {
      if (res?.payload?.success) {
        setClients(res?.payload?.data);
      }
    });
  };

  const handleGetAssignedTasks = () => {
    const payload = { search };
    dispatch(getAssignedTasks(payload)).then((res) => {
      if (res?.payload?.success) {
        const formattedUsers = res?.payload?.data.map((task) => ({
          ...task,
          id: String(task.id)
        }));
        setAssignedTasks(formattedUsers);
      }
    });
  };

  const handleGetAllUsers = () => {
    dispatch(getAllUsers()).then((res) => {
      if (res?.payload?.success) {
        // const taskCountMap = {};
        // assignedTasks.forEach((task) => {
        //   if (task.user_id) {
        //     taskCountMap[task.user_id] = (taskCountMap[task.user_id] || 0) + 1;
        //   }
        // });
        const taskCountMap = {};
        const taskHoursMap = {};

        assignedTasks.forEach((task) => {
          const userId = task.user_id;

          if (userId) {
            // count tasks
            taskCountMap[userId] = (taskCountMap[userId] || 0) + 1;

            // sum hours (convert string → number)
            const hours = Number(task?.task?.hours || 0);
            taskHoursMap[userId] = (taskHoursMap[userId] || 0) + hours;
          }
        });

        // const teamArray = res?.payload?.data
        //   .filter((user) => user.isActive) // Only include active users with role_id 2
        //   .map((user) => {
        //     const hasTask = taskCountMap[user.id] > 0;

        //     return {
        //       id: user.id.toString(),
        //       name: `${user.first_name} ${user.last_name}`,
        //       avatar: '/api/placeholder/40/40',
        //       ...(hasTask
        //         ? { taskCount: taskCountMap[user.id] }
        //         : { available: true })
        //     };
        //   });
        const teamArray = res?.payload?.data
          .filter((user) => user.isActive)
          .map((user) => {
            const hasTask = taskCountMap[user.id] > 0;

            return {
              id: user.id.toString(),
              name: `${user.first_name} ${user.last_name}`,
              avatar: '/api/placeholder/40/40',
              taskCount: taskCountMap[user.id] || 0,
              totalHours: taskHoursMap[user.id] || 0,
              // available: !hasTask,
              on_leave: Boolean(user.on_leave), // for display only; not used in conditions
              available: !hasTask, // derived from task assignment only

              staff_augmentation: user.staff_augmentation ?? false,
              staff_augmentation_percentage:
                user.staff_augmentation_percentage ?? 0,
              role_id: user.role_id,

              ...(user.leave_start_date != null && {
                leave_start_date: user.leave_start_date
              }),
              ...(user.leave_end_date != null && {
                leave_end_date: user.leave_end_date
              }),
              ...(user.leave_type != null && { leave_type: user.leave_type })
            };
          });

        setTeam(teamArray);
      }
    });
  };

  //delete task
  const handleDeleteTask = (id) => {
    const payload = { id, is_active: false };
    dispatch(createNewTask(payload)).then((res) => {
      if (res?.payload?.success) {
        handleGetAllTasks();
      }
    });
  };

  // Toggle task highlight state
  const toggleHighlight = (taskId) => {
    const newTasks = Array.from(tasks);
    const taskIndex = newTasks.findIndex((task) => task.id === taskId);

    if (taskIndex !== -1) {
      newTasks[taskIndex] = {
        ...newTasks[taskIndex],
        highlighted: !newTasks[taskIndex].highlighted
      };
      setTasks(newTasks);
    }
  };

  const getUnassignedTasks = () => {
    // return tasks.filter((task) => !task.assigned_to);
    return tasks;
  };
  const getTasksByMember = (memberName) => {
    return assignedTasks
      .filter(
        (task) =>
          `${task?.user?.first_name} ${task?.user?.last_name}` === memberName
      )
      .sort((a, b) => b.is_highlight - a.is_highlight);
  };

  // Handle the end of a drag operation
  const onDragEnd = (result) => {
    const { source, destination } = result;

    // Dropped outside the list
    if (!destination) {
      return;
    }

    // Moving within the unassigned tasks list
    if (
      source.droppableId === 'taskList' &&
      destination.droppableId === 'taskList'
    ) {
      // If the item was dropped in a different position
      if (source.index !== destination.index) {
        const newTasks = Array.from(tasks);
        const unassignedTasks = getUnassignedTasks();
        const [movedTask] = unassignedTasks.splice(source.index, 1);

        // Find the index in the original array
        const taskIndex = newTasks.findIndex(
          (task) => task.id === movedTask.id
        );

        if (taskIndex !== -1) {
          // Remove the task from its original position
          newTasks.splice(taskIndex, 1);

          // Calculate the new position and insert
          const remainingUnassigned = getUnassignedTasks();
          let insertIndex = 0;

          if (destination.index < remainingUnassigned.length) {
            const targetTaskId = remainingUnassigned[destination.index].id;
            insertIndex = newTasks.findIndex(
              (task) => task.id === targetTaskId
            );
          } else {
            // If dropping at the end, find the last unassigned task's index and add after it
            insertIndex =
              Math.max(
                ...remainingUnassigned.map((task) =>
                  newTasks.findIndex((t) => t.id === task.id)
                )
              ) + 1;
          }

          newTasks.splice(insertIndex, 0, movedTask);
          setTasks(newTasks);
        }
      }
    }

    // Moving from unassigned tasks to a team member
    else if (
      source.droppableId === 'taskList' &&
      destination.droppableId.startsWith('member-')
    ) {
      const memberName = destination.droppableId.replace('member-', '');
      const unassignedTasks = getUnassignedTasks();
      const taskToMove = unassignedTasks[source.index];

      if (taskToMove) {
        // Find and update the task
        const teamMember = team.find((member) => member.name === memberName);

        if (teamMember) {
          // const userId = teamMember.id;
          // const taskId = taskToMove.id;
          let payload = { task_id: taskToMove.id, user_id: teamMember.id };
          // Make API call to update task assignment
          dispatch(updateTaskAssignment(payload)).then((res) => {
            if (res?.payload?.success) {
              handleGetAssignedTasks();
              handleGetAllTasks();
            }
          });
          const newTasks = Array.from(tasks);
          const taskIndex = newTasks.findIndex(
            (task) => task.id === taskToMove.id
          );

          if (taskIndex !== -1) {
            newTasks[taskIndex] = {
              ...newTasks[taskIndex],
              assignedTo: memberName
            };
            setTasks(newTasks);

            // Update team member task count
            const newTeam = Array.from(team);
            const memberIndex = newTeam.findIndex(
              (member) => member.name === memberName
            );

            if (memberIndex !== -1) {
              newTeam[memberIndex] = {
                ...newTeam[memberIndex],
                taskCount: (newTeam[memberIndex].taskCount || 0) + 1,
                available: false
              };
              setTeam(newTeam);
            }
          }
        }
      }
    }
  };

  const removeTaskFromMember = (taskId) => {
    const payload = { task_id: taskId };
    dispatch(unAssignedTask(payload)).then((res) => {
      if (res?.payload?.success) {
        handleGetAssignedTasks();
        handleGetAllTasks();
      }
    });
  };

  const handleHighlightTask = (taskId, memberId) => {
    const payload = { plan_id: taskId };
    const foundHighlightedTask = highlightedTasksMemberIds.find(
      (taskMemberId) => taskMemberId === memberId
    );

    if (foundHighlightedTask) {
      message.error(
        'Unhighlight previously highlighted tasks to highlight this'
      );
      return;
    } else {
      dispatch(highlightTask(payload)).then((res) => {
        if (res?.payload?.success) {
          setHighlightedTasksMemberIds([
            ...highlightedTasksMemberIds,
            memberId
          ]);
          handleGetAssignedTasks();
          handleGetAllTasks();
        }
      });
    }
  };

  const handleunhighlightTask = (taskId, memberId) => {
    const payload = { plan_id: taskId };

    setHighlightedTasksMemberIds((prevMembers) => {
      return prevMembers.filter((member) => member !== memberId);
    });
    dispatch(unhighlightTask(payload)).then((res) => {
      if (res?.payload?.success) {
        handleGetAssignedTasks();
        handleGetAllTasks();
      }
    });
  };

  const handlePublish = () => {
    const payload = {
      is_published: true,
      plan_date: date
    };
    navigate('/publish-plan', { state: { plan_date: date } });
    // dispatch(publishPlan(payload)).then((res) => {
    //   if (res?.payload?.success) {
    //     handleGetAssignedTasks();
    //     handleGetAllTasks();
    //   }
    // });
  };

  const handleDisableDate = (currDate) => {
    // return isBefore(currDate, new Date());
    const today = startOfDay(new Date());
    return isBefore(currDate, today);
  };

  console.log('team', team);

  const filteredTeam = team.filter(
    (member) =>
      !(
        member.staff_augmentation === true &&
        (member.staff_augmentation_percentage ?? 0) >= 100
      )
  );

  const isMemberDisabledForLeave = (member) => {
    if (!member.leave_start_date || !member.leave_end_date) return false;

    const today = startOfDay(new Date());
    const tomorrow = addDays(today, 1);

    const leaveStart = startOfDay(parseISO(member.leave_start_date));
    const leaveEnd = startOfDay(parseISO(member.leave_end_date));

    // ✅ Case 1: Single day leave
    if (isSameDay(leaveStart, leaveEnd)) {
      // Disable ONLY the day before
      return isSameDay(leaveStart, tomorrow);
    }

    // ✅ Case 2: Leave starts tomorrow → disable today
    if (isSameDay(leaveStart, tomorrow)) {
      return true;
    }

    // ✅ Case 3: Today is on or after leave start and before leave end (multi-day leave: e.g. leave 17–18, today 17 → disabled)
    if (
      (isSameDay(today, leaveStart) || isAfter(today, leaveStart)) &&
      isBefore(today, leaveEnd)
    ) {
      return true;
    }

    // ✅ Case 4: Leave ends today → AVAILABLE
    if (isSameDay(today, leaveEnd)) {
      return false;
    }

    return false;
  };

  const activeMembers = team.filter(
    (member) =>
      !isMemberDisabledForLeave(member) &&
      member.staff_augmentation_percentage !== 100 &&
      member.role_id !== 3
  );

  const avgUtilizationPercentage =
    activeMembers.length > 0
      ? (activeMembers.reduce((sum, member) => {
          const divisor =
            Number(member.staff_augmentation_percentage) === 50 ? 4 : 8;

          return sum + Number(member.totalHours || 0) / divisor;
        }, 0) /
          activeMembers.length) *
        100
      : 0;

  return (
    <section className={'mb-12 overflow-hidden md:overflow-y-auto'}>
      <div className="flex flex-col items-start justify-between gap-2 md:flex-row">
        <div className="flex items-center gap-4">
          <Title level={5} className={'!text-xl !m-0 lg:!text-3xl !font-bold'}>
            Plan work for team
          </Title>
          <Link
            to={'/plans'}
            className="!font-bold !text-xs hover:!text-white text-black bg-white hover:!bg-[#0653fa] !transition-all !duration-300"
            style={{
              fontFamily: 'SFProText Bold',
              border: '1px solid #dddddd',
              borderRadius: '4px',
              paddingBlock: '4px',
              paddingInline: '6px'
            }}
          >
            All Plans
          </Link>
          <Button
            type="default"
            className="!font-bold !text-xs hover:!text-white text-black bg-white hover:!bg-[#0653fa] hover:!border-[#0653fa] !transition-all !duration-300"
            style={{
              fontFamily: 'SFProText Bold',
              border: '1px solid #dddddd',
              borderRadius: '4px',
              paddingBlock: '4px',
              paddingInline: '6px',
              height: '27px'
            }}
            onClick={() => setLeavesModalOpen(true)}
          >
            Leaves
          </Button>
        </div>
        <div className="flex justify-end md:justify-center">
          <Space>
            {/* {user?.user_details?.role_id === EXECUTIVE && (
              <div className="flex items-center gap-2">
                <div>Total Utilization:</div>
                <Text strong>{avgUtilizationPercentage.toFixed(2)}%</Text>
              </div>
            )} */}

            <DatePicker
              // showTime
              onChange={(value, dateString) => {
                setDate(dateString);
              }}
              placeholder="Select Date"
              disabledDate={handleDisableDate}
            />
            <CustomButton
              type="primary"
              onClick={handlePublish}
              disabled={!date}
            >
              <SendOutlined /> Publish Plan
            </CustomButton>
          </Space>
        </div>
      </div>
      <br />
      <DragDropContext onDragEnd={onDragEnd}>
        <Row gutter={24}>
          <Col span={12}>
            <Col>
              <div
                className={` bg-[#fff] relative rounded-lg shadow-bottom p-6`}
                bordered={false}
              >
                <div className="flex !text-[#64748b] !text-sm font-semibold justify-end w-full gap-2 mb-2">
                  <label>Total tasks:</label>
                  <span>{getUnassignedTasks().length || 0}</span>
                </div>
                <Row gutter={24} className="!sticky !top-0 ">
                  <Col span={8}>
                    <Select
                      showSearch
                      placeholder="All Clients"
                      optionFilterProp="children"
                      // defaultValue="all"
                      style={{ width: '100%' }}
                      className={styles.selectField}
                      onChange={onChange}
                      // options={clients}
                    >
                      <option value="">All Clients</option>
                      {clients?.length
                        ? clients?.map((item, index) => {
                            return (
                              <option value={item?.id} key={index}>
                                {item?.client_name}
                              </option>
                            );
                          })
                        : ''}
                    </Select>
                  </Col>
                  <Col span={16}>
                    <Input
                      placeholder="Search tasks..."
                      prefix={<SearchOutlined />}
                      className={styles.Searchbox}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </Col>
                </Row>

                <Droppable droppableId="taskList">
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      className="max-h-screen mt-4 overflow-y-scroll"
                    >
                      {getUnassignedTasks().length ? (
                        getUnassignedTasks().map((task, index) => (
                          <Draggable
                            key={task.id}
                            draggableId={task.id}
                            index={index}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                style={{
                                  ...provided.draggableProps.style,
                                  marginBottom: '16px'
                                }}
                              >
                                <Card
                                  className={styles.actionCard2}
                                  bordered={false}
                                >
                                  <Row gutter={24}>
                                    <Col
                                      span={18}
                                      {...provided.dragHandleProps}
                                    >
                                      <Space align="center">
                                        <HolderOutlined />
                                        <Title
                                          level={5}
                                          className={styles.taskTitle}
                                          style={{ margin: 0 }}
                                        >
                                          {task.title}
                                        </Title>
                                      </Space>
                                    </Col>
                                    <Col
                                      span={6}
                                      style={{ textAlign: 'right', padding: 0 }}
                                    >
                                      {task.task_type === 'ad_hoc' && (
                                        <Tag bordered={false} color="purple">
                                          Ad-hoc
                                        </Tag>
                                      )}
                                      {task.priority && (
                                        <Tag bordered={false} color="red">
                                          Priority
                                        </Tag>
                                      )}
                                    </Col>
                                  </Row>
                                  <Row gutter={24}>
                                    <Col span={24}>
                                      <Text
                                        type="secondary"
                                        className={styles.descriptionText}
                                      >
                                        {task?.description || 'NA'}
                                      </Text>
                                    </Col>
                                  </Row>
                                  <Row gutter={24}>
                                    <Col span={18}>
                                      <Text
                                        type="secondary"
                                        className={styles.secondaryText}
                                      >
                                        {task.client.client_name} ·{' '}
                                        {task.project.project} · {`T${task.id}`}
                                      </Text>
                                    </Col>
                                    <Col
                                      span={6}
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        paddingRight: '-0px'
                                      }}
                                    >
                                      <Button
                                        type="text"
                                        size="small"
                                        onClick={() =>
                                          setIsTaskAssignModalOpen(task.id)
                                        }
                                        icon={
                                          <UserAddOutlined
                                            style={{
                                              color: 'gray',
                                              cursor: 'pointer'
                                            }}
                                          />
                                        }
                                      />

                                      <Button
                                        type="text"
                                        size="small"
                                        onClick={() => setEditTaskId(task.id)}
                                        icon={
                                          <EditOutlined
                                            style={{
                                              color: 'gray',
                                              cursor: 'pointer'
                                            }}
                                          />
                                        }
                                      />
                                      <Popconfirm
                                        title={
                                          <>
                                            <div>Please Confirm</div>
                                            <div
                                              style={{
                                                color: 'rgba(0, 0, 0, 0.45)'
                                              }}
                                            >
                                              Are you sure you want to delete
                                              this task?
                                            </div>
                                          </>
                                        }
                                        onConfirm={() =>
                                          handleDeleteTask(task.id)
                                        }
                                        okText="Delete"
                                        cancelText="No"
                                      >
                                        <Button
                                          type="text"
                                          size="small"
                                          icon={
                                            <DeleteOutlined
                                              style={{
                                                color: 'gray',
                                                cursor: 'pointer'
                                              }}
                                            />
                                          }
                                        />
                                      </Popconfirm>
                                    </Col>
                                  </Row>
                                </Card>
                              </div>
                            )}
                          </Draggable>
                        ))
                      ) : (
                        <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description="No tasks to assign"
                        />
                      )}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
            </Col>
          </Col>

          <Col span={12}>
            <Card className={`!mb-4 ${styles.actionCard1}`} bordered={false}>
              <div
                style={{ marginBottom: '24px' }}
                className="flex justify-between"
              >
                <Title
                  level={5}
                  style={{
                    margin: 0,
                    color: '#666',
                    fontWeight: 'bold',
                    fontSize: '14px'
                  }}
                  className="!whitespace-nowrap"
                >
                  ACTIVE CONTRIBUTORS
                </Title>

                <div className="flex !text-[#64748b] !text-sm font-semibold justify-end w-full gap-3 mb-2">
                  {user?.user_details?.role_id === EXECUTIVE && (
                    <div className="flex items-center gap-2">
                      <div>Total Utilization:</div>
                      <span>{avgUtilizationPercentage.toFixed(2)}%</span>
                    </div>
                  )}
                  <label>Assigned tasks:</label>
                  <span>{assignedTasks.length || 0}</span>
                </div>
              </div>
              <div className="max-h-[55vh] overflow-y-auto">
                {team.filter(
                  (member) =>
                    !member.available && !isMemberDisabledForLeave(member)
                ).length ? (
                  team
                    .filter(
                      (member) =>
                        !member.available && !isMemberDisabledForLeave(member)
                    )
                    .map((member) => {
                      // let hasHighlighted = getTasksByMember(member.name).some(
                      //   (item) => item.highlighted === true
                      // );
                      // console.log(member, 'member');
                      return (
                        <div
                          key={member.id}
                          style={{
                            marginBottom: '24px',
                            borderBottom: '1px solid #f0f0f0',
                            paddingBottom: '24px'
                          }}
                        >
                          <Card className={styles.actionCard1} bordered={false}>
                            <Row
                              align="middle"
                              style={{
                                marginBottom: '16px',
                                justifyContent: 'space-between'
                              }}
                            >
                              <Col span={16}>
                                <Space>
                                  <Avatar src={member.avatar}>
                                    {member.name
                                      .split(' ')
                                      .map((word) => word[0])
                                      .join('')}
                                  </Avatar>
                                  <Text strong>{member.name}</Text>
                                </Space>
                              </Col>
                              <Row style={{ gap: '10px' }}>
                                {user?.user_details?.role_id === EXECUTIVE && (
                                  <Row span={8} style={{ textAlign: 'right' }}>
                                    {/* <Text
                                      type="secondary"
                                      className={styles.taskCount}
                                    >
                                      <ClockCircleOutlined /> {` `}
                                      {member.taskCount}
                                      {` `} hrs{' '}
                                    </Text> */}
                                    <Text
                                      type="secondary"
                                      className={styles.taskCount}
                                    >
                                      <ClockCircleOutlined />{' '}
                                      {member.totalHours || 0} hrs
                                    </Text>
                                  </Row>
                                )}
                                <Row span={8} style={{ textAlign: 'right' }}>
                                  <Text
                                    type="secondary"
                                    className={styles.taskCount}
                                  >
                                    {member.taskCount} tasks
                                  </Text>
                                </Row>
                              </Row>
                            </Row>
                            <Droppable droppableId={`member-${member.name}`}>
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.droppableProps}
                                >
                                  {getTasksByMember(member.name).map((task) => (
                                    <div
                                      key={task.id}
                                      style={{
                                        marginBottom: '8px'
                                      }}
                                    >
                                      <Row
                                        align="middle"
                                        style={{
                                          padding: '4px 8px 4px 8px',
                                          backgroundColor: task.highlighted
                                            ? '#fffbe6'
                                            : '#fff',
                                          border: '1px solid #f0f0f0',
                                          borderRadius: '4px'
                                        }}
                                      >
                                        <Col span={16}>
                                          <Space>
                                            {task?.task?.priority && (
                                              <ThunderboltFilled
                                                className={styles.thunderIcon}
                                              />
                                            )}
                                            <Text
                                              className={styles.projectText}
                                            >
                                              {task.task.title}
                                            </Text>
                                          </Space>
                                        </Col>
                                        <Col
                                          span={8}
                                          style={{ textAlign: 'right' }}
                                        >
                                          <Space>
                                            <Button
                                              type="text"
                                              icon={
                                                !task.is_highlight ? (
                                                  <Space>
                                                    <StarOutlined
                                                      onClick={() =>
                                                        handleHighlightTask(
                                                          task.id,
                                                          task.user?.id
                                                        )
                                                      }
                                                    />
                                                  </Space>
                                                ) : task.is_highlight ? (
                                                  <StarFilled
                                                    onClick={() =>
                                                      handleunhighlightTask(
                                                        task.id,
                                                        task.user?.id
                                                      )
                                                    }
                                                    style={{ color: '#F59E0B' }}
                                                  />
                                                ) : (
                                                  ''
                                                )
                                              }
                                              size="small"
                                              onClick={() =>
                                                toggleHighlight(task.id)
                                              }
                                            />
                                            <Button
                                              type="text"
                                              icon={<CloseOutlined />}
                                              size="small"
                                              onClick={() =>
                                                removeTaskFromMember(
                                                  task.task.id
                                                )
                                              }
                                            />
                                          </Space>
                                        </Col>
                                      </Row>
                                    </div>
                                  ))}
                                  {provided.placeholder}
                                </div>
                              )}
                            </Droppable>
                          </Card>
                        </div>
                      );
                    })
                ) : (
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                )}
              </div>
            </Card>

            <Card className={`!mb-4 ${styles.actionCard1}`} bordered={false}>
              <div style={{ marginBottom: '16px' }}>
                <Title
                  level={5}
                  style={{
                    margin: 0,
                    color: '#666',
                    fontWeight: 'bold',
                    fontSize: '14px'
                  }}
                >
                  AVAILABLE TEAM MEMBERS
                </Title>
              </div>

              <div className="max-h-[110vh] overflow-y-auto">
                {filteredTeam
                  .filter((member) => member.available)
                  .map((member) => (
                    <div key={member.id} className="mb-4">
                      <Droppable
                        droppableId={`member-${member.name}`}
                        isDropDisabled={isMemberDisabledForLeave(member)}
                      >
                        {(provided) => {
                          const disabled = isMemberDisabledForLeave(member);
                          return (
                            <Card
                              className={styles.actionCard1}
                              bordered={false}
                              style={{
                                cursor: disabled ? 'not-allowed' : undefined
                              }}
                            >
                              <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                              >
                                <Row
                                  align="middle"
                                  style={{
                                    padding: '12px',
                                    backgroundColor: disabled
                                      ? '#F3F4F6'
                                      : '#FFF',
                                    border: disabled
                                      ? '1px solid #E6E6E6'
                                      : '1px solid #F0F0F0',
                                    borderTopRightRadius: '4px',
                                    borderTopLeftRadius: '4px'
                                  }}
                                >
                                  <Col span={16}>
                                    <Space>
                                      <Avatar
                                        src={member.avatar}
                                        style={
                                          !disabled
                                            ? { backgroundColor: '#A1D98C' }
                                            : undefined
                                        }
                                      >
                                        {member.name
                                          .split(' ')
                                          .map((word) => word[0])
                                          .join('')}
                                      </Avatar>
                                      <Text strong>{member.name}</Text>
                                    </Space>
                                  </Col>
                                  <Col span={8} style={{ textAlign: 'right' }}>
                                    {disabled ? (
                                      <Space>
                                        <Text
                                          type="secondary"
                                          className={styles.secondaryText}
                                          style={{ color: '#64748b' }}
                                        >
                                          <Text
                                            type="secondary"
                                            className={styles.secondaryText}
                                            style={{ color: '#64748b' }}
                                          >
                                            Date:{' '}
                                          </Text>
                                          {member.leave_start_date &&
                                          member.leave_end_date
                                            ? (() => {
                                                const start = parseISO(
                                                  member.leave_start_date
                                                );
                                                const end = parseISO(
                                                  member.leave_end_date
                                                );
                                                const startStr = format(
                                                  start,
                                                  'dd MMM'
                                                );
                                                const endStr = format(
                                                  end,
                                                  'dd MMM'
                                                );
                                                return isSameDay(start, end)
                                                  ? startStr
                                                  : `${startStr} - ${endStr}`;
                                              })()
                                            : '—'}
                                        </Text>
                                        {/* <Tooltip title="Revoke leave">
                                        <span
                                          className="p-1 rounded hover:bg-[#DBDBDB] cursor-pointer inline-flex items-center justify-center"
                                          onClick={() => {
                                            dispatch(
                                              updateUserLeaveStatus({
                                                id: Number(member.id),
                                                cancel_leave: true
                                              })
                                            ).then((res) => {
                                              if (res?.payload?.success) {
                                                handleGetAllUsers();
                                              }
                                            });
                                          }}
                                        >
                                          <LogoutOutlined
                                            style={{
                                              color: 'gray',
                                              transform: 'scaleX(-1)'
                                            }}
                                          />
                                        </span>
                                      </Tooltip> */}
                                      </Space>
                                    ) : (
                                      <Space size={12}>
                                        <Text type="secondary">Available</Text>

                                        <Switch
                                          size="small"
                                          checked={false}
                                          onChange={(checked) => {
                                            if (checked) {
                                              setSelectedMember(member);
                                              setLeaveModalOpen(true);
                                            }
                                          }}
                                        />

                                        <Text type="secondary">Leave</Text>
                                      </Space>
                                    )}
                                  </Col>
                                </Row>
                                <div
                                  style={{
                                    padding: '8px 12px',
                                    textAlign: 'center',
                                    color: '#bbb',
                                    // border: '1px dashed #f0f0f0',
                                    border: disabled
                                      ? '1px solid #E6E6E6'
                                      : '1px solid #F0F0F0',
                                    borderTop: 'none',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',
                                    backgroundColor: disabled
                                      ? '#F3F4F6'
                                      : '#FFF'
                                  }}
                                >
                                  {disabled
                                    ? 'Member on leave'
                                    : 'Drop tasks here'}
                                  {/* Drop tasks here */}
                                </div>
                                {provided.placeholder}
                              </div>
                            </Card>
                          );
                        }}
                      </Droppable>
                    </div>
                  ))}
              </div>
            </Card>
          </Col>
        </Row>
      </DragDropContext>

      {/* task assign modal */}
      <TaskAssignModal
        isOpen={isTaskAssignModal}
        setIsOpen={setIsTaskAssignModalOpen}
        taskData={tasks.find((task) => task.id === isTaskAssignModal)}
        // team={
        //   team.filter((member) => !member.available).length
        //     ? team.filter((member) => !member.available)
        //     : []
        // }
        team={filteredTeam}
        onAssign={() => {
          handleGetAssignedTasks();
          handleGetAllTasks();
        }}
      />
      {/* task edit modal */}
      <FloatingActionButton
        taskId={editTaskId}
        setTaskId={setEditTaskId}
        handleGetAllTasks={handleGetAllTasks}
        taskData={getUnassignedTasks().find((task) => task.id === editTaskId)}
      />
      {user?.user_details?.role_id === 1 ? (
        <FloatingActionButton handleGetAllTasks={handleGetAllTasks} />
      ) : (
        ''
      )}
      <LeaveModal
        visible={leaveModalOpen}
        member={selectedMember}
        onClose={() => {
          setLeaveModalOpen(false);
          setSelectedMember(null);
        }}
        onSuccess={handleGetAllUsers}
      />
      <LeavesModal
        visible={leavesModalOpen}
        onClose={() => setLeavesModalOpen(false)}
        membersOnLeave={team.filter(
          (member) => member.leave_start_date && member.leave_end_date
        )}
        onSuccess={handleGetAllUsers}
      />
    </section>
  );
};

export default TaskPlanner;
